import { ActionType, createAsyncAction } from 'typesafe-actions';
import { DefaultErrorPayload, FetchAction, SuccessFetchActionPayload } from '../dataFetching/generators';
import { DataFetchingThunkAction } from '../types';
import { log404ErrorAsWarning } from '../../../common/apiAdapters/ErrorHandlers';
import { LookPromotionResponse } from './types';

export const fetchLooksPromotionActions = createAsyncAction(
    '@LOOKS_PROMOTION/FETCH_START',
    '@LOOKS_PROMOTION/FETCH_SUCCESS',
    '@LOOKS_PROMOTION/FETCH_FAILED'
)<FetchAction, SuccessFetchActionPayload<LookPromotionResponse>, DefaultErrorPayload>();

export const fetchLooksPromotionIfNeeded = (): DataFetchingThunkAction => async (
    dispatch,
    getState,
    { apiService, logger }
) => {
    const identifier = 'fetchLooksPromotionIfNeeded';
    if (getState().looksPromotionalElements.identifier === identifier) {
        return;
    }
    dispatch(fetchLooksPromotionActions.request({ identifier }));
    try {
        const data = await apiService.shopApi.getLookPromotion();
        dispatch(fetchLooksPromotionActions.success({ data, identifier }));
    } catch (err) {
        log404ErrorAsWarning(err, '', logger, 'fetchLooksPromotionIfNeeded');
        dispatch(fetchLooksPromotionActions.failure({ error: err, identifier }));
    }
};

export type LooksPromotionActionType = ActionType<typeof fetchLooksPromotionActions>;
